export const COMPANY = {
    name: "Tømrerfirmaet Fyr og Finér ApS",
    shortName: "Fyr & Finér",
    owner: "Markus Ley",
    role: "Tømrer · Sølvmedalje 2025",
    silverMedalImage:
        "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/qldzhiqs_ffff.jpg",
    phone: "61 31 63 63",
    phoneHref: "tel:+4561316363",
    email: "fyrogfiner@gmail.com",
    emailHref: "mailto:fyrogfiner@gmail.com",
    address: "Stubmarken 28, 3230 Græsted",
    cvr: "45845737",
    parent: "Markus Ley Holding ApS",
    logo: "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/hysyfqgz_T%C3%B8mrerfirmaet%20Fyr%20og%20Fin%C3%A9r%20Logo.jpg",
    portrait:
        "https://customer-assets.emergentagent.com/job_markus-toemrer/artifacts/lfgu654f_Markus%20Dr%C3%A6by%20Ley.jpg",
    facebook:
        "https://web.facebook.com/p/T%C3%B8mrerfirmaet-Fyr-og-fin%C3%A9r-61579866544946/",
    instagram: "https://www.instagram.com/fyrogfiner/",
};
